import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import index from '../views/index'
import tab_user from '../views/tab_user'
import liuyan from '../views/liuyan'

const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/user',
        name: 'tab_user',
        component: tab_user
    },
    {
        path: '/liuyan',
        name: 'liuyan',
        component: liuyan
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    // }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
